class Helper {

    static sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    static getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

}


class StateChecker
{
    #id = 0;

    getID()
    {
        return this.#id;
    }
    constructor()
    {
        this.#id = Helper.getRandomInt(10000);
    }

    isSame(otherState)
    {
        return this.#id === otherState.getID();
    }
}

class Tones {
    static toneOscillatorContext = new (window.AudioContext || window.webkitAudioContext)();
    // Long-lived oscillators keyed by streamId, used for v3 hold-to-talk
    // attention tones. Entry shape: { osc, vol }.
    static sustainedOscillators = new Map();

    static startSustainedTone(streamId, freq)
    {
        if(!streamId || !freq) { return; }
        if(this.sustainedOscillators.has(streamId)) {
            console.debug("Sustained tone "+streamId+" already playing, ignoring");
            return;
        }
        try {
            if(this.toneOscillatorContext.state === "suspended") {
                this.toneOscillatorContext.resume();
            }
            let osc = this.toneOscillatorContext.createOscillator();
            let vol = this.toneOscillatorContext.createGain();
            vol.gain.value = 0.1;
            osc.type = "sine";
            osc.frequency.value = freq;
            osc.connect(vol);
            vol.connect(this.toneOscillatorContext.destination);
            osc.start();
            this.sustainedOscillators.set(streamId, { osc: osc, vol: vol });
        } catch(e) {
            console.error("startSustainedTone failed", e);
        }
    }

    static stopSustainedTone(streamId)
    {
        if(!streamId) { return; }
        let entry = this.sustainedOscillators.get(streamId);
        if(!entry) {
            console.debug("Sustained tone "+streamId+" not active, ignoring stop");
            return;
        }
        try { entry.osc.stop(); } catch(e) {}
        try { entry.osc.disconnect(); } catch(e) {}
        try { entry.vol.disconnect(); } catch(e) {}
        this.sustainedOscillators.delete(streamId);
    }

    static generateClearAlert()
    {
        this.generateTone(910, 100);
    }

    // Rev 8 reconnect-handling: session-failed alarm. 300Hz sine, ~1s with
    // soft attack/release so the dispatcher gets an audible "your console
    // session just dropped" cue without a hard speaker click. Fired exactly
    // once per Failed transition (guarded at the ConsoleSession layer), not
    // per retry attempt.
    static playAlarmTone()
    {
        try {
            const ctx = this.toneOscillatorContext;
            if(ctx.state === "suspended") {
                ctx.resume().catch(() => {});
            }
            const osc = ctx.createOscillator();
            const vol = ctx.createGain();
            osc.type = "sine";
            osc.frequency.value = 300;
            osc.connect(vol);
            vol.connect(ctx.destination);
            const now = ctx.currentTime;
            const attack = 0.05;
            const sustain = 0.9;
            const release = 0.05;
            const peak = 0.15;
            vol.gain.setValueAtTime(0, now);
            vol.gain.linearRampToValueAtTime(peak, now + attack);
            vol.gain.setValueAtTime(peak, now + attack + sustain);
            vol.gain.linearRampToValueAtTime(0, now + attack + sustain + release);
            osc.start(now);
            osc.stop(now + attack + sustain + release + 0.05);
        } catch(e) {
            console.warn("[Tones] playAlarmTone failed", e);
        }
    }
    static generatePTT(clearAlert)
    {
        let beepLengthShort = 30;
        let beepLengthMid = 50;
        let waitShort = 20;
        let beepLong = 150;
        let waitLong = 80;
        this.generateToneAtSpecificTime(910,beepLengthShort);
        this.generateToneAtSpecificTime(910,beepLengthShort,beepLengthShort+waitShort);
        this.generateToneAtSpecificTime(910,beepLengthMid,beepLengthShort+waitShort+beepLengthShort+waitShort);
        if(clearAlert)
            this.generateToneAtSpecificTime(910,100,beepLengthShort+waitShort+beepLengthShort+waitShort+beepLengthMid+waitLong);
    };


    static generateBoop(length)
    {
        if(length===undefined)
        {
            length = 150
        }
        this.generateTone(910, length,);
    };

    static generateBeep(length)
    {
        if(length===undefined)
        {
            length = 250
        }
        this.generateTone(910, length,);
    };

    static generateBonk(length = 250)
    {
        return this.generateTone(400,length);
    };

    static playAlertTone(toneType)
    {
        switch (toneType)
        {
            case "A":
                this.generateTone(900,3000);
                break;
            case "B":
                this.generateTone(900,250,()=>{
                    setTimeout(()=>{
                        this.generateTone(900,250,()=>{
                            setTimeout(()=>{
                                this.generateTone(900,250,()=>{
                                    setTimeout(()=>{
                                        this.generateTone(900,250,()=>{
                                            setTimeout(()=>{
                                                this.generateTone(900,250,()=>{
                                                })
                                            },250)
                                        })
                                    },250)
                                })
                            },250)
                        })
                    },250)
                });
                break;
            case "C":
                this.generateTone(700,250,()=>{
                    this.generateTone(900,250,()=>{
                        this.generateTone(700,250,()=>{
                            this.generateTone(900,250,()=>{
                                this.generateTone(700,250,()=>{
                                    this.generateTone(900,250,()=>{
                                        this.generateTone(700,250,()=>{
                                            this.generateTone(900,250,()=>{
                                                this.generateTone(700,250,()=>{
                                                    this.generateTone(900,250,()=>{

                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
                break;
            case "HOLD":
                this.generateTone(700,500,()=>{
                });
        }
    }

    static generateQuikCallPage(tone1, tone2) {
        this.generateTone(this.getQuikCallFrequency(tone1), 1000, () => {
            this.generateTone(this.getQuikCallFrequency(tone2), 3000)
        })
    }

    static getQuikCallFrequency(target) {
        switch (Number(target)) {
            case 110:
                return 330.5;
            case 111:
                return 349;
            case 112:
                return 368.5;
            case 113:
                return 389;
            case 114:
                return 410.8;
            case 115:
                return 433.7;
            case 116:
                return 457.9;
            case 117:
                return 483.5;
            case 118:
                return 510.5;
            case 119:
                return 539;
            case 120:
                return 569.1;
            case 121:
                return 600.9;
            case 122:
                return 634.5;
            case 123:
                return 669.9;
            case 124:
                return 707.3;
            case 125:
                return 746.8;
            case 126:
                return 788.5;
            case 127:
                return 832.5;
            case 128:
                return 879;
            case 129:
                return 928.1;
            case 138:
                return 288.5;
            case 108:
                return 296.5;
            case 139:
                return 304.7;
            case 109:
                return 313.8;
            case 160:
                return 953.7;
            case 130:
                return 979.9;
            case 161:
                return 1006.9;
            case 131:
                return 1034.7;
            case 162:
                return 1063.2;
            case 189:
                return 1092.4;
            case 140:
                return 321.7;
            case 141:
                return 339.6;
            case 142:
                return 358.6;
            case 143:
                return 378.6;
            case 144:
                return 399.8;
            case 145:
                return 422.1;
            case 146:
                return 445.7;
            case 147:
                return 470.5;
            case 148:
                return 496.8;
            case 149:
                return 524.6;
            case 150:
                return 553.9;
            case 151:
                return 584.8;
            case 152:
                return 617.4;
            case 153:
                return 651.9;
            case 154:
                return 688.3;
            case 155:
                return 726.8;
            case 156:
                return 767.4;
            case 157:
                return 810.2;
            case 158:
                return 855.5;
            case 159:
                return 903.2;
            case 190:
                return 1122.5;
            case 191:
                return 1153.4;
            case 192:
                return 1185.2;
            case 193:
                return 1217.8;
            case 194:
                return 1251.4;
            case 195:
                return 1285.8;
            case 196:
                return 1321.2;
            case 197:
                return 1357.6;
            case 198:
                return 1395;
            case 199:
                return 1433.4;
            case 170:
                return 1472.9;
            case 171:
                return 1513.5;
            case 172:
                return 1555.2;
            case 173:
                return 1598;
            case 174:
                return 1642;
            case 175:
                return 1687.2;
            case 176:
                return 1733.7;
            case 177:
                return 1781.5;
            case 178:
                return 1830.5;
            case 179:
                return 1881;
            case 200:
                return 1930.2;
            case 201:
                return 1989;
            case 202:
                return 2043.8;
            case 203:
                return 2094.5;
            case 204:
                return 2155.6;
            case 205:
                return 2212.2;
            case 206:
                return 2271.7;
            case 207:
                return 2334.6;
            case 208:
                return 2401;
            case 209:
                return 2468.2;
        }
    }

    static generateToneAtSpecificTime(freq,length,delay=0)
    {
        length = length/1000;
        delay = delay/1000;
        let osc = this.toneOscillatorContext.createOscillator();
        let vol = this.toneOscillatorContext.createGain();
        vol.gain.value = 0.1;
        if(freq!=0) {
            osc.type = 'sine'; // this is the default - also square, sawtooth, triangle
            osc.frequency.value = freq; // Hz
            osc.connect(vol); // connect it to the destination
            vol.connect(this.toneOscillatorContext.destination);
            console.debug("schedule tone of "+freq+"hz")
            console.debug("at "+this.toneOscillatorContext.currentTime+delay)
            console.debug("to end at "+(this.toneOscillatorContext.currentTime+length-delay))
            osc.start(this.toneOscillatorContext.currentTime+delay);
            osc.stop(((this.toneOscillatorContext.currentTime+length)+delay));
        }
    }

    static toneStopper;

    static generateTone(freq,length,callback)
    {
        let osc = this.toneOscillatorContext.createOscillator();
        let vol = this.toneOscillatorContext.createGain();
        vol.gain.value = 0.1;
        if(freq!=0) {
            osc.type = 'sine'; // this is the default - also square, sawtooth, triangle
            osc.frequency.value = freq; // Hz
            osc.connect(vol); // connect it to the destination
            vol.connect(this.toneOscillatorContext.destination);
            osc.start();
            this.toneStopper=osc.stop;
            if(length==0)
            {
                let stop=false;
                setInterval(function(){
                    if(stop)
                    {
                        osc.stop();
                        return false;
                    }
                },100);
                return function(){
                    stop=true;
                };
            }
        }
        setTimeout(function(){
            if(freq!=0)
                osc.stop();
            if(callback)
            {
                callback();
            }
        },length)
    }
}

class OpCodes
{
    static CCUPDATE = 0x001;
    static REGISTER = 0x110;
    static DEREGISTER = 0x111;
    static REGISTRATION_OK = 0x210;
    static REGISTRATION_DENIED = 0x211;
    static REGISTRATION_FAILED = 0x212;
    static DEREGISTER_ANNOUNCE = 0x213;
    static AFFILIATE = 0x120;
    static DEAFFILIATE = 0x121;
    static DEAFFILIATE_ANNOUNCE = 0x222;
    static AFFILIATE_OK = 0x220;
    static AFFILIATE_DENIED = 0x221;
    static EMERGENCY = 0x131;
    static EMERGENCY_CLEAR = 0x132;
    static EMERGENCY_FORCE_CLEAR = 0x135;
    static CHANNEL_REQ = 0x141;
    static CHANNEL_REL = 0x142;
    static CHANNEL_GRANT = 0x241;
    static CHANNEL_DENY = 0x242;
    static CHANNEL_ANNOUNCE = 0x243;
    static CHANNEL_REL_ANNOUNCE = 0x244;
    static REMOTE_INHIBIT = 0x250;
    static REMOTE_UNINHIBIT = 0x251;
    static PATCH_ANNOUNCE = 0x260;
    static PATCH_RELEASE_ANNOUNCE = 0x261;
    static REMOTE_PING = 0x280;
    static REMOTE_PING_RESPONSE = 0x180;
    static QUERY_LOCATION = 0x1001;
    static QUERY_RESPONSE = 0x1901
}

class CAIDataPacket
{
    messageID
    subscriber
    target
    payload
    messageKey

    /**
     * @param {number} opcode
     * @param {number} subscriber
     * @param {number} target
     * @param {object} payload
     * @param {number} messageKey
     */
    constructor(opcode,subscriber,target,payload,messageKey)
    {
        this.messageID = opcode;
        this.subscriber = subscriber;
        this.target = target;
        this.payload = payload;
        this.messageKey = messageKey;
    }
}

class CAIDataObject
{
    packet = undefined;
    key = undefined;

    /**
     * @param {string} key
     * @param {CAIDataPacket} packet
     */
    constructor(key,packet) {
        this.packet = packet;
        this.key = key;
    }

    sendTo(socket)
    {
        socket.emit("CAIData",this);
    }
}


// IncomingSubscriberCall — dedicated audio path for a radio TXing back into a
// TG that this console is preempting. Per the Rev 7 follow-up, this is the
// private channel between server and the preempting console; other consoles
// don't see it (no fanout). Each instance owns its own Voice driver so its
// audio output can be muted/volumed independently of the main per-TG path.
//
// Placeholder wire (suggested by Steven; signaling agent will finalize):
//   incoming_subscriber_call       { consoleRid, channel, radioRid, alias,
//                                    talkgroup }
//   incoming_subscriber_call_ended { consoleRid, radioRid, talkgroup }
//
// The encryption key is NEVER on the wire. Server doesn't hold keys (SHA-256
// of human strings; client-side only). The preempting console looks the key
// up locally from the TG's view-config entry — the console is already
// affiliated to the TG and has the key in hand. Caller (ConsoleSession)
// resolves the key and passes it into the constructor.
class IncomingSubscriberCall {
    consoleRid;
    radioRid;
    radioAlias;
    talkgroup;
    encryptionKey;      // resolved by caller from view config; NOT from wire.
    channel;            // vc-room inner-string (no `vc[…]` brackets); Voice wraps.
    voice;              // dedicated Voice driver; one per incoming sub call.
    muted = false;
    volume = 1.0;
    _socket;

    constructor(socket, info, encryptionKey, serverRev8)
    {
        this._socket = socket;
        this.consoleRid = info.consoleRid;
        this.radioRid = info.radioRid;
        this.radioAlias = info.alias;
        this.talkgroup = info.talkgroup;
        this.encryptionKey = encryptionKey;
        this.channel = info.channel;

        // Spin up a dedicated Voice instance. Subscriber/alias are this
        // console's identity (so outbound encoder, if ever engaged, stamps
        // them correctly), but for this object we're listen-only.
        try {
            this.voice = new Voice(socket);
            if(typeof this.voice.setSubscriber === "function") {
                this.voice.setSubscriber(this.consoleRid);
            }
            if(typeof this.voice.setEncryptionKey === "function") {
                this.voice.setEncryptionKey("vc[" + this.channel + "]", this.encryptionKey);
            }
            // Rev 8: joinedTg = this.talkgroup. Server's bridge stamps
            // targetTalkgroup on incoming-subscriber frames; per-frame
            // validation here drops any cross-TG leak before decode.
            // serverRev8 gates that per-frame validation — pre-Rev-8 servers
            // don't stamp, so unstamped frames must be allowed (PL-2).
            this.voice.setVoiceChannel(this.channel, this.talkgroup, !!serverRev8);
        } catch(e) {
            console.error("IncomingSubscriberCall voice init failed", e);
        }
    }

    setMuted(muted)
    {
        this.muted = !!muted;
        this._applyVolume();
    }

    setVolume(v)
    {
        const n = Number(v);
        if(!Number.isFinite(n)) return;
        this.volume = Math.max(0, Math.min(1, n));
        this._applyVolume();
    }

    _applyVolume()
    {
        if(!this.voice || typeof this.voice.setVolume !== "function") return;
        this.voice.setVolume(this.muted ? 0 : this.volume);
    }

    teardown()
    {
        if(this.voice) {
            try { this.voice.leaveVoiceChannel(); } catch(_) {}
            this.voice = null;
        }
    }
}

// ConsoleSession — single-RID console for Rev 7. Replaces the per-channel
// WebRadio model. Owns the full activate/confirm/affiliate/heartbeat/deactivate
// handshake, preempt routing, call-lifecycle broadcasts, and tone wire. UI
// (per-channel Channel objects in dispatchpanel.js) registers listeners to
// react to call/grant/release events.
class ConsoleSession {
    // Rev 8 preempt-room protocol (vc_stream_transition, vc_no_call,
    // enriched channel_preempt_ok, per-frame targetTalkgroup) → v1.1.
    // Server denies channel_preempt to v1.0 consoles with reason="client_too_old".
    static PROTOCOL_VERSION = "v1.1";
    static CLIENT_VERSION = "scn-web";

    socket;
    systemKey;       // legacy 'key' field for systemTone/tone_start wire
    sysID;           // viewConfig.sysID — base for consoleRid = sysID + 1 + offset
    talkgroups;      // list of TGs to affiliate
    identity;
    displayName;
    aliasLabel;      // view-config prefix; default "DISPATCH"; combined with
                     // (offset + 1) to form consoleAlias stamped on every
                     // outbound v3_packet / systemTone / tone_start.
    // tgID -> per-TG encryption key from view config. Keys are SHA-256 of
    // human strings and live client-side only (server never sees them), so
    // the preempting-console audio path looks them up from here when an
    // incoming_subscriber_call arrives.
    talkgroupKeys;

    offset;
    consoleRid;
    consoleAlias;    // "<aliasLabel> <offset+1>", derived in _onActivateOk
    expiresAtMs;
    heartbeatIntervalMs;
    heartbeatTimeoutMs;
    allowPreempt = false;
    allowRadioIntoConsole = false;
    // Rev 8 capability handshake: set from console_activate_ok.serverProtocolVersion.
    // True iff server echoed "v1.1" in the ack — i.e., signaling server speaks
    // the Rev-8 vc-room protocol (per-frame targetTalkgroup stamping, etc.).
    // Default false covers both pre-Rev-8 servers (which don't echo the field)
    // and any future >v1.1 negotiation not yet implemented client-side
    // (fail-closed: no Rev 8 features assumed without explicit ack).
    serverRev8 = false;

    // "idle" | "activating" | "confirming" | "affiliating" | "active" |
    // "pool_exhausted" | "failed" | "deactivating" | "v2_legacy"
    //
    // "v2_legacy" is the runtime fallback for pre-Rev-7 signaling servers that
    // don't know the `console_activate` event at all (socket.io silently drops
    // unknown events, so there's no error/reject — only timeout). When the
    // ack timer fires without any reply, the session synthesizes a stable RID
    // (sysID + 1, the offset-0 convention) and sends v2-style AFFILIATE
    // packets. requestTx/releaseTx still work — they route through the
    // existing CAIData/CHANNEL_REQ path which is also the v2 wire format.
    // serverRev8 stays false (no Rev-8 features against a pre-Rev-7 server).
    state = "idle";

    // Rev 8 capability handshake (PL-5): activate-ack watchdog. Pre-Rev-7
    // servers ignore the `console_activate` event entirely — no ok/failed,
    // just silence — so only a timeout can distinguish them. 2.5s picked as
    // the defensible middle: healthy networks ack in <100ms, congested links
    // in <1s, so 2.5s avoids false-trips while keeping the operator-visible
    // hang short. Cleared by _onActivateOk and _onActivateFailed.
    static ACTIVATE_ACK_TIMEOUT_MS = 2500;

    // v2_legacy registration keepalive. The legacy server's inactivity sweep
    // runs every 100 s and de-registers anyone un-pinged across two passes, so
    // 30 s leaves ample margin even when a hidden tab is timer-throttled.
    static LEGACY_KEEPALIVE_MS = 30000;
    // TrunkingCCError.NOT_AFFILIATED — carried in CHANNEL_DENY.payload when the
    // server has no (or no longer any) registration for the requesting RID.
    static DENY_NOT_AFFILIATED = 0xB03;
    _activateAckTimer = null;

    // Populated from CAIData CHANNEL_ANNOUNCE (and snapshot.activeCalls if
    // provided). Per Rev 7 follow-up the dedicated call_* events are gone —
    // CAIData is the authoritative source for "what's TXing on which TG".
    perTGCallState = new Map();   // tgID -> { rid, channelID }
    perTGEmergencies = new Map(); // tgID -> subscriberID
    perTGChannelID = new Map();   // tgID -> last seen channelID from CHANNEL_ANNOUNCE; consulted on preempt grant
    // TGs this client is locally TXing on. Per Steven, "the call is the same
    // [post-preempt], just with a different RID and alias" — no server broadcast
    // tells other clients the talker changed. So self-busy must be local-only.
    localActiveTxTGs = new Set();
    // Indexed by `${talkgroup}:${radioRid}` per the placeholder wire shape.
    // Holds IncomingSubscriberCall instances for the second audio path that
    // opens when a radio TXes back into a TG we're preempting.
    incomingSubscriberCalls = new Map();

    listeners = {};
    _localActiveStreamIds = new Set();
    _heartbeatTimer = null;
    _pendingChannelReq = null;    // { messageKey, tg, resolve, timer }
    _pendingPreempt = null;       // { tg, resolve, timer }
    _wasConnectedOnce = false;
    _deactivateAckResolvers = [];
    // Rev 8 reconnect handling: per-instance backoff state. Resets on every
    // successful console_activate_ok. Schedule is 1s/2s/4s/8s/16s/30s, then
    // 30s repeating forever (server-managed hold window is 120s; if we
    // missed it, we still keep trying — fresh RID is fine, UI re-stamps).
    _reactivateBackoffSchedule = [1000, 2000, 4000, 8000, 16000, 30000];
    _reactivateAttempt = 0;
    _reactivateTimer = null;
    // Set true exactly once per Active→Failed transition so the alarm tone
    // doesn't re-fire on retry-loop disconnect/reconnect churn. Cleared on
    // the next Active.
    _alarmedThisFailureCycle = false;

    constructor(socket, opts)
    {
        this.socket = socket;
        this.sysID = opts.sysID;
        this.systemKey = opts.systemKey;
        this.talkgroups = (opts.talkgroups || []).slice();
        // Rev 8: stable per-instance identity UUID. Sent on every
        // console_activate (initial + reactivate) so the server-side hold
        // window (120s as of B2026.05H) can restore the same RID after a
        // wire blip. Generated once at session construction; never persisted
        // across page reloads (a fresh tab/reload is a new identity, which
        // is what the server's hold-window contract expects).
        this.identity = (typeof opts.identity === "string" && opts.identity.length > 0)
            ? opts.identity
            : ConsoleSession._mintIdentity();
        this.displayName = opts.displayName;
        this.aliasLabel = (typeof opts.aliasLabel === "string" && opts.aliasLabel.length > 0)
            ? opts.aliasLabel
            : "DISPATCH";
        this.talkgroupKeys = opts.talkgroupKeys instanceof Map
            ? new Map(opts.talkgroupKeys)
            : new Map();
        this._registerWireHandlers();
        this._registerSocketLifecycle();
    }

    static _mintIdentity()
    {
        if(typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
            return crypto.randomUUID();
        }
        // Pre-randomUUID fallback (older Safari). RFC 4122 v4 shape.
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    setListeners(listeners) { Object.assign(this.listeners, listeners || {}); }

    // ---- wire registration ----

    _registerWireHandlers()
    {
        this.socket.on("console_activate_ok", d => this._onActivateOk(d));
        this.socket.on("console_activate_failed", d => this._onActivateFailed(d));
        this.socket.on("console_confirm_ok", d => this._onConfirmOk(d));
        this.socket.on("console_confirm_failed", d => this._onConfirmFailed(d));
        this.socket.on("console_affiliate_ok", d => this._onAffiliateOk(d));
        this.socket.on("console_heartbeat_ok", d => this._onHeartbeatOk(d));
        this.socket.on("console_heartbeat_failed", d => this._onHeartbeatFailed(d));
        this.socket.on("console_deactivate_ok", d => this._onDeactivateOk(d));
        this.socket.on("channel_preempt_ok", d => this._onPreemptOk(d));
        this.socket.on("channel_preempt_denied", d => this._onPreemptDenied(d));
        // Per Rev 7 follow-up from Steven: the call_started/call_released/
        // call_updated event surface is dropped. Existing CAIData
        // CHANNEL_ANNOUNCE/REL_ANNOUNCE plus per-frame v3_packet metadata
        // covers what listeners need; preempt is the only fan-out that needs
        // a non-CAIData event, and even it's now caller-only.
        //
        // The preempting-console's inbound-subscriber audio path is private
        // and uses dedicated placeholder events (wire TBD by signaling agent).
        this.socket.on("incoming_subscriber_call", d => this._onIncomingSubscriberCall(d));
        this.socket.on("incoming_subscriber_call_ended", d => this._onIncomingSubscriberCallEnded(d));
        this.socket.on("CAIData", d => this._onCAIData(d));
        this.socket.on("systemTone", d => this._onSystemTone(d));
        this.socket.on("tone_start", d => this._onToneStart(d));
        this.socket.on("tone_stop", d => this._onToneStop(d));
    }

    _registerSocketLifecycle()
    {
        this.socket.on("connect", () => {
            if(!this._wasConnectedOnce) {
                // First-time connect; initial activate is triggered explicitly
                // by initialSetup. Don't compete with it.
                this._wasConnectedOnce = true;
                return;
            }
            // Rev 8 reconnect: schedule reactivate with backoff. Pool-exhausted
            // requires manual retry per existing Rev 7 UX; don't auto-loop
            // from that terminal state.
            if(this.state === "pool_exhausted") {
                return;
            }
            console.info("[ConsoleSession] socket reconnected; scheduling reactivate");
            this._scheduleReactivate();
        });
        this.socket.on("disconnect", () => {
            console.warn("[ConsoleSession] socket disconnect");
            this._stopHeartbeat();
            // v2_legacy keepalive is equally meaningless without a wire; a
            // reconnect re-enters _onActivateAckTimeout and restarts it.
            this._stopLegacyKeepalive();
            const prevRid = this.consoleRid;
            const prevState = this.state;
            // Rev 8: only fire the alarm tone on the first Failed transition
            // from a previously-live session. If we were already in failed
            // (i.e., wire bouncing during reactivate retries), don't re-alarm.
            const wasLiveSession = (
                prevState === "active" ||
                prevState === "activating" ||
                prevState === "confirming" ||
                prevState === "affiliating" ||
                prevState === "v2_legacy"
            );
            // Cancel any in-flight activate-ack watchdog. Disconnect during
            // the timeout window means we'll start fresh on reconnect.
            this._clearActivateAckTimer();
            // Cancel any in-flight reactivate timer — fresh connect will
            // re-schedule from the connect handler.
            if(this._reactivateTimer) {
                clearTimeout(this._reactivateTimer);
                this._reactivateTimer = null;
            }
            this.consoleRid = undefined;
            this.expiresAtMs = undefined;
            // Rev 8: Failed (not idle). Idle was "have not yet activated";
            // Failed is "we lost a session." UI distinguishes these — Failed
            // raises a banner + blocks PTT + drives the auto-reactivate loop.
            this.state = "failed";
            this.perTGCallState.clear();
            this.perTGEmergencies.clear();
            this.perTGChannelID.clear();
            this.localActiveTxTGs.clear();
            // Drop local sustained tones — wire is gone.
            for(const sid of this._localActiveStreamIds) {
                try { Tones.stopSustainedTone(sid); } catch(_) {}
            }
            this._localActiveStreamIds.clear();
            // Tear down any open incoming-subscriber audio paths — the audio
            // wire's gone with the socket.
            for(const call of this.incomingSubscriberCalls.values()) {
                try { call.teardown(); } catch(_) {}
            }
            this.incomingSubscriberCalls.clear();
            if(wasLiveSession && !this._alarmedThisFailureCycle) {
                this._alarmedThisFailureCycle = true;
                try { Tones.playAlarmTone(); } catch(_) {}
            }
            if(this.listeners.onSessionLost) {
                try { this.listeners.onSessionLost({ prevRid, prevState }); } catch(_) {}
            }
        });
    }

    // ---- lifecycle methods ----

    activate()
    {
        if(this.state === "pool_exhausted") {
            // Manual retry only.
        }
        this.state = "activating";
        this._clearActivateAckTimer();
        this._activateAckTimer = setTimeout(() => {
            this._activateAckTimer = null;
            this._onActivateAckTimeout();
        }, ConsoleSession.ACTIVATE_ACK_TIMEOUT_MS);
        // `key` is REQUIRED since B2026.05F: the server keys the console's
        // ControlChannel off the client-supplied system key (no auto-resolve,
        // no synthesized DEFAULT). Omitting it gets console_activate_failed
        // {reason:"bad_proto"} — see SocketService console_activate.
        this.socket.emit("console_activate", {
            protocolVersion: ConsoleSession.PROTOCOL_VERSION,
            key: this.systemKey,
            identity: this.identity,
            displayName: this.displayName,
            clientKind: "web",
            clientVersion: ConsoleSession.CLIENT_VERSION
        });
    }

    _clearActivateAckTimer()
    {
        if(this._activateAckTimer) {
            clearTimeout(this._activateAckTimer);
            this._activateAckTimer = null;
        }
    }

    // Rev 8 capability handshake (PL-5): no ack within ACTIVATE_ACK_TIMEOUT_MS
    // → the server is pre-Rev-7 and doesn't speak `console_activate` at all.
    // Synthesize a stable RID (offset-0 convention), affiliate via the v2
    // CAIData wire, and flip state to "v2_legacy" so requestTx works through
    // the existing CHANNEL_REQ path (which is also the v2 PTT wire). UI is
    // notified via the same onActive listener so the dispatcher sees a normal
    // active session — the routing-version difference is internal.
    _onActivateAckTimeout()
    {
        // Defensive: an ack that arrived between timer fire and this handler
        // running (or after a manual deactivate) should take precedence.
        if(this.state !== "activating") { return; }
        // serverRev8 stays false (no Rev-8 wire surface against a v2 server).
        this.serverRev8 = false;
        this.offset = 0;
        this.consoleRid = this.sysID + 1;
        this.consoleAlias = this.aliasLabel + " 1";
        this.state = "v2_legacy";
        // Legacy (pre-Rev-7) servers allocate ONE RID PER CHANNEL — they grant
        // per subscriber, not per console. Affiliating a single console RID to
        // every TG makes the server deny the moment we key anything other than
        // the first talkgroup (CHANNEL_DENY 0x242 against sysID+1).
        //
        // Reproduce the pre-Rev-7 dispatchpanel allocation exactly:
        //   webRadioID = sysID;  radioID = webRadioID += 1   (per channel)
        // i.e. sysID+1, sysID+2, ... in view-config order. `talkgroups` is
        // built channels-first, so index order matches the legacy numbering.
        //
        // Each RID must REGISTER before it AFFILIATEs — a legacy server has no
        // subscriber record to grant a channel to otherwise.
        this.legacyRidByTg = new Map();
        this.talkgroups.forEach((tg, i) => {
            this.legacyRidByTg.set(tg, this.sysID + 1 + i);
        });
        this._registerLegacyRids();
        // No `console_heartbeat` in v2 — the server doesn't know that event.
        // But legacy registrations DO expire, so start the CAIData keepalive.
        this._startLegacyKeepalive();
        // Reset reactivate backoff: we've reached a stable terminal state,
        // not an error condition that should keep retrying. A disconnect/
        // reconnect will re-run activate() naturally and re-discover.
        this._clearReactivateTimer();
        this._reactivateAttempt = 0;
        this._alarmedThisFailureCycle = false;
        console.info("[ConsoleSession] activate ack timeout — server is pre-Rev-7; entering v2_legacy mode,"
            + " per-channel RIDs " + JSON.stringify(Array.from(this.legacyRidByTg.entries())));
        if(this.listeners.onActive) {
            try {
                this.listeners.onActive({
                    rid: this.consoleRid,
                    talkgroups: this.talkgroups,
                    legacy: true,
                    // Per-channel RID map — dispatchpanel stamps each tile with
                    // its own RID instead of the shared console RID.
                    ridByTg: this.legacyRidByTg
                });
            } catch(_) {}
        }
    }

    // ---- v2_legacy registration upkeep -----------------------------------
    //
    // Legacy servers AGE SUBSCRIBERS OUT. `signaling-server.js` runs a sweep
    // every 100 s (when `enablePing` is set, which is the default on every
    // configured system): each pass clears `lastPing`, and any subscriber
    // still un-pinged on the FOLLOWING pass is de-registered "for inactivity".
    // So an idle console is dropped after 100-200 s, and its next CHANNEL_REQ
    // comes back CHANNEL_DENY with payload NOT_AFFILIATED (0xB03) — the
    // operator-visible symptom being a bonk on PTT with RX still working
    // (voice relay is room-based, not registration-gated) until a page reload.
    //
    // Note the server never SENDS `REMOTE_PING` (0x280) — it only handles an
    // inbound `REMOTE_PING_RESPONSE` (0x180) via handlePingPacket ->
    // setPing(subscriber). The keepalive is therefore unsolicited by design:
    // we emit 0x180 ourselves, per RID, well inside the sweep window.

    // One REGISTER + AFFILIATE pair per per-channel legacy RID. Safe to repeat:
    // the server treats a duplicate REGISTER as a liveness refresh
    // (`registerSubscriber` sets lastPing = true and logs "Duplicate
    // registration"). Guarded for `disallowDualReg` systems, where a duplicate
    // is rejected — there the keepalive ping is what keeps us alive.
    _registerLegacyRids()
    {
        if(!this.legacyRidByTg) { return; }
        for(const [tg, rid] of this.legacyRidByTg.entries()) {
            this.socket.emit("CAIData", new CAIDataObject(this.systemKey,
                new CAIDataPacket(OpCodes.REGISTER, rid, 0, 0, Helper.getRandomInt(1000))));
            this.socket.emit("CAIData", new CAIDataObject(this.systemKey,
                new CAIDataPacket(OpCodes.AFFILIATE, rid, 0, tg, 0)));
        }
    }

    // Emit REMOTE_PING_RESPONSE for every legacy RID. Interval is well under
    // the 100 s sweep so even a background tab (Chromium clamps timers in
    // hidden tabs, worst case ~1/min) still lands at least one ping per pass.
    _startLegacyKeepalive()
    {
        this._stopLegacyKeepalive();
        this._legacyKeepaliveTimer = setInterval(() => {
            if(this.state !== "v2_legacy" || !this.legacyRidByTg) { return; }
            for(const rid of this.legacyRidByTg.values()) {
                this.socket.emit("CAIData", new CAIDataObject(this.systemKey,
                    new CAIDataPacket(OpCodes.REMOTE_PING_RESPONSE, rid, 0, 0, 0)));
            }
        }, ConsoleSession.LEGACY_KEEPALIVE_MS);
    }

    _stopLegacyKeepalive()
    {
        if(this._legacyKeepaliveTimer) {
            clearInterval(this._legacyKeepaliveTimer);
            this._legacyKeepaliveTimer = null;
        }
    }

    retryActivate()
    {
        if(this.state === "pool_exhausted" || this.state === "failed") {
            // Manual retry from a banner button bypasses backoff and resets
            // the attempt counter — the operator has signaled "now."
            this._clearReactivateTimer();
            this._reactivateAttempt = 0;
            this.activate();
        }
    }

    // ---- Rev 8 reactivate backoff ----

    _clearReactivateTimer()
    {
        if(this._reactivateTimer) {
            clearTimeout(this._reactivateTimer);
            this._reactivateTimer = null;
        }
    }

    // Schedule the next reactivate attempt against the backoff schedule.
    // Idempotent — re-scheduling clears the prior timer. Capped at the last
    // schedule entry (30s) and tries forever from there.
    _scheduleReactivate()
    {
        this._clearReactivateTimer();
        const schedule = this._reactivateBackoffSchedule;
        const idx = Math.min(this._reactivateAttempt, schedule.length - 1);
        const delay = schedule[idx];
        const attempt = this._reactivateAttempt + 1;
        console.info("[ConsoleSession] reactivate attempt " + attempt + " in " + delay + "ms");
        this._reactivateTimer = setTimeout(() => {
            this._reactivateTimer = null;
            // Bail if the socket dropped again while we were waiting; the
            // next connect handler will reschedule.
            if(!this.socket || this.socket.connected === false) {
                return;
            }
            // Bail if a successful activate already happened (e.g., manual
            // retry race).
            if(this.state === "active" || this.state === "activating"
                || this.state === "confirming" || this.state === "affiliating") {
                return;
            }
            this._reactivateAttempt = attempt;
            this.activate();
        }, delay);
    }

    _onActivateOk(d)
    {
        if(!d) { return; }
        this._clearActivateAckTimer();
        this.offset = d.offset;
        this.expiresAtMs = d.expiresAtMs;
        this.heartbeatIntervalMs = d.heartbeatIntervalMs || 5000;
        this.heartbeatTimeoutMs = d.heartbeatTimeoutMs || 30000;
        this.allowPreempt = !!d.allowPreempt;
        this.allowRadioIntoConsole = !!d.allowRadioIntoConsole;
        // Rev 8 capability handshake (PL-1): server stamps serverProtocolVersion
        // on the activate ack. Only "v1.1" turns on Rev-8 strict validation
        // downstream; absent or any other value is treated as pre-Rev-8.
        this.serverRev8 = (d.serverProtocolVersion === "v1.1");
        this.consoleRid = this.sysID + 1 + this.offset;
        // Offset is 0-indexed on the wire; the human-facing alias number is
        // 1-indexed (offset 0 → "DISPATCH 1"). FiveM radios surface this
        // string on mid-call talker swap when a console preempts a radio.
        this.consoleAlias = this.aliasLabel + " " + (this.offset + 1);
        console.info("[ConsoleSession] activate_ok offset=" + this.offset
            + " rid=" + this.consoleRid + " alias=" + this.consoleAlias);
        this.state = "confirming";
        this.socket.emit("console_confirm", { offset: this.offset, rid: this.consoleRid });
    }

    _onActivateFailed(d)
    {
        this._clearActivateAckTimer();
        console.warn("[ConsoleSession] activate_failed", d);
        if(d && d.reason === "pool_exhausted") {
            this.state = "pool_exhausted";
            // Terminal until manual retry: stop the reactivate loop.
            this._clearReactivateTimer();
            this._reactivateAttempt = 0;
            if(this.listeners.onPoolExhausted) {
                try { this.listeners.onPoolExhausted(d); } catch(_) {}
            }
        } else {
            this.state = "failed";
            if(this.listeners.onActivateFailed) {
                try { this.listeners.onActivateFailed(d); } catch(_) {}
            }
            // Auto-retry with backoff. Will be cancelled by a fresh
            // disconnect (which will reschedule on next connect) or by a
            // manual retryActivate() click.
            this._scheduleReactivate();
        }
    }

    _onConfirmOk(d)
    {
        if(!d) { return; }
        if(d.rid !== this.consoleRid) {
            console.warn("[ConsoleSession] confirm_ok rid mismatch", d.rid, "vs", this.consoleRid);
        }
        this.expiresAtMs = d.expiresAtMs;
        this.state = "affiliating";
        this.socket.emit("console_affiliate", {
            rid: this.consoleRid,
            talkgroups: this.talkgroups
        });
    }

    _onConfirmFailed(d)
    {
        console.warn("[ConsoleSession] confirm_failed", d);
        this.state = "failed";
        if(this.listeners.onConfirmFailed) {
            try { this.listeners.onConfirmFailed(d); } catch(_) {}
        }
        // Treat confirm_failed identically to activate_failed for retry
        // purposes — the server may have hit a transient and a fresh
        // activate cycle is the right recovery.
        this._scheduleReactivate();
    }

    _onAffiliateOk(d)
    {
        if(!d) { return; }
        this.state = "active";
        // Rev 8: successful activate→confirm→affiliate cycle resets the
        // reconnect backoff state. The alarm-guard also clears so the next
        // Failed transition gets a fresh alarm cue.
        this._clearReactivateTimer();
        this._reactivateAttempt = 0;
        this._alarmedThisFailureCycle = false;
        console.info("[ConsoleSession] active rid=" + this.consoleRid + " tgs=" + JSON.stringify(d.talkgroups));
        if(d.snapshot) {
            this._applySnapshot(d.snapshot);
        }
        this._startHeartbeat();
        if(this.listeners.onActive) {
            try { this.listeners.onActive({ rid: this.consoleRid, talkgroups: d.talkgroups, snapshot: d.snapshot }); } catch(_) {}
        }
    }

    _applySnapshot(snap)
    {
        if(Array.isArray(snap.activeCalls)) {
            for(const c of snap.activeCalls) {
                if(c.talkgroup === undefined) continue;
                this.perTGCallState.set(c.talkgroup, {
                    rid: c.rid,
                    channelID: c.channelID
                });
                if(c.channelID !== undefined) {
                    this.perTGChannelID.set(c.talkgroup, c.channelID);
                }
            }
        }
        if(Array.isArray(snap.emergencies)) {
            for(const e of snap.emergencies) {
                if(e.talkgroup === undefined) continue;
                this.perTGEmergencies.set(e.talkgroup, e.subscriber);
                if(this.listeners.onEmergency) {
                    try { this.listeners.onEmergency(e); } catch(_) {}
                }
            }
        }
        if(Array.isArray(snap.tones)) {
            for(const t of snap.tones) {
                if(t.streamId && t.tone1) {
                    try { Tones.startSustainedTone(t.streamId, t.tone1); } catch(_) {}
                }
            }
        }
        if(Array.isArray(snap.patches) && this.listeners.onPatchSnapshot) {
            try { this.listeners.onPatchSnapshot(snap.patches); } catch(_) {}
        }
    }

    _startHeartbeat()
    {
        this._stopHeartbeat();
        this._heartbeatTimer = setInterval(() => {
            if(this.consoleRid && this.state === "active") {
                this.socket.emit("console_heartbeat", { rid: this.consoleRid });
            }
        }, this.heartbeatIntervalMs || 5000);
    }

    _stopHeartbeat()
    {
        if(this._heartbeatTimer) {
            clearInterval(this._heartbeatTimer);
            this._heartbeatTimer = null;
        }
    }

    _onHeartbeatOk(d)
    {
        if(d) { this.expiresAtMs = d.expiresAtMs; }
    }

    _onHeartbeatFailed(d)
    {
        console.warn("[ConsoleSession] heartbeat_failed", d);
        if(d && d.reason === "unknown_rid") {
            this._stopHeartbeat();
            this.consoleRid = undefined;
            this.state = "idle";
            this.activate();
        }
    }

    deactivate()
    {
        if(this.state === "idle" || !this.consoleRid) {
            return Promise.resolve();
        }
        this._stopHeartbeat();
        this._stopLegacyKeepalive();
        const rid = this.consoleRid;
        this.state = "deactivating";
        this.socket.emit("console_deactivate", { rid: rid });
        return new Promise((resolve) => {
            const timer = setTimeout(() => {
                const i = this._deactivateAckResolvers.indexOf(entry);
                if(i !== -1) this._deactivateAckResolvers.splice(i, 1);
                resolve();
            }, 1500);
            const entry = { rid: rid, resolve: resolve, timer: timer };
            this._deactivateAckResolvers.push(entry);
        });
    }

    _onDeactivateOk(d)
    {
        const rid = d && d.rid;
        this.state = "idle";
        this.consoleRid = undefined;
        this.expiresAtMs = undefined;
        this.perTGCallState.clear();
        this.perTGEmergencies.clear();
        this.perTGChannelID.clear();
        this.localActiveTxTGs.clear();
        for(const call of this.incomingSubscriberCalls.values()) {
            try { call.teardown(); } catch(_) {}
        }
        this.incomingSubscriberCalls.clear();
        // Resolve pending deactivate promises.
        const pending = this._deactivateAckResolvers.splice(0);
        for(const e of pending) {
            clearTimeout(e.timer);
            try { e.resolve(); } catch(_) {}
        }
    }

    // ---- PTT classification + routing ----

    classifyCall(tg)
    {
        // Local self-busy check first: server doesn't broadcast preempts to
        // other consoles, so perTGCallState[tg].rid may still show the radio
        // we preempted (or be empty entirely if we requestTx'd on idle). Our
        // own active-TX set is the authoritative "we're TXing" signal.
        if(this.localActiveTxTGs.has(tg)) return "self";
        const c = this.perTGCallState.get(tg);
        if(!c) return "idle";
        return "busy";
    }

    // Resolve the RID to put on the wire for a given talkgroup.
    // Rev-7+ : the single console RID is affiliated to every view TG.
    // v2_legacy: legacy servers grant per subscriber, so each channel keys
    // under its OWN RID (sysID + 1 + index). Falls back to the console RID if
    // the TG isn't in the map (e.g. a tone TG added after activation).
    ridForTg(tg)
    {
        if(this.state === "v2_legacy" && this.legacyRidByTg) {
            const rid = this.legacyRidByTg.get(tg);
            if(rid) { return rid; }
        }
        return this.consoleRid;
    }

    // Decide PTT path and resolve when TX is granted (or denied).
    // Returns { status: "granted" | "granted_preempt" | "denied", channelID?, reason? }.
    async requestTx(tg)
    {
        const live = (this.state === "active" || this.state === "v2_legacy");
        if(!live || !this.consoleRid) {
            return { status: "denied", reason: "not_active" };
        }
        if(this.localActiveTxTGs.has(tg)) {
            return { status: "denied", reason: "self_already_tx" };
        }
        let result;
        if(this.state === "v2_legacy") {
            // v2 servers don't speak `channel_preempt` — busy/idle classification
            // would route to a dead wire. Always emit the CHANNEL_REQ CAIData
            // packet; the v2 server's grant-or-deny is the only arbitration.
            result = await this._sendChannelReq(tg);
            // Self-heal: NOT_AFFILIATED means the server has no registration
            // for this RID — almost always because its inactivity sweep aged
            // us out. Re-register every RID and retry once, so the operator
            // gets their transmission instead of a bonk + "reload the page".
            // Deliberately scoped to this one code: TALKGROUP_BUSY and
            // NO_CHANNEL_FREE are legitimate refusals and must NOT be retried.
            if(result && result.status === "denied"
                && result.denyCode === ConsoleSession.DENY_NOT_AFFILIATED) {
                console.warn("[ConsoleSession] CHANNEL_REQ denied NOT_AFFILIATED —"
                    + " registration aged out; re-registering and retrying once");
                this._registerLegacyRids();
                result = await this._sendChannelReq(tg);
            }
        } else {
            const cls = this.classifyCall(tg);
            if(cls === "busy") {
                // Let server decide if it's another console (denied) vs radio (preempt ok).
                result = await this._sendPreempt(tg);
            } else {
                result = await this._sendChannelReq(tg);
            }
        }
        if(result && (result.status === "granted" || result.status === "granted_preempt")) {
            this.localActiveTxTGs.add(tg);
        }
        return result;
    }

    _sendChannelReq(tg)
    {
        const messageKey = Helper.getRandomInt(1000);
        return new Promise((resolve) => {
            const timer = setTimeout(() => {
                if(this._pendingChannelReq && this._pendingChannelReq.messageKey === messageKey) {
                    this._pendingChannelReq = null;
                    resolve({ status: "denied", reason: "timeout" });
                }
            }, 5000);
            this._pendingChannelReq = { messageKey, tg, resolve, timer };
            this.socket.emit("CAIData", new CAIDataObject(this.systemKey,
                new CAIDataPacket(OpCodes.CHANNEL_REQ, this.ridForTg(tg), 0, tg, messageKey)));
        });
    }

    _sendPreempt(tg)
    {
        return new Promise((resolve) => {
            const timer = setTimeout(() => {
                if(this._pendingPreempt && this._pendingPreempt.tg === tg) {
                    this._pendingPreempt = null;
                    resolve({ status: "denied", reason: "timeout" });
                }
            }, 5000);
            this._pendingPreempt = { tg, resolve, timer };
            this.socket.emit("channel_preempt", { rid: this.consoleRid, talkgroup: tg });
        });
    }

    _onPreemptOk(d)
    {
        if(!d) { return; }
        if(this._pendingPreempt && this._pendingPreempt.tg === d.talkgroup) {
            clearTimeout(this._pendingPreempt.timer);
            const cb = this._pendingPreempt;
            this._pendingPreempt = null;
            // Rev 8: server now hands back the fully-formed preempt-room
            // name (preemptVc) plus displaced-talker metadata. The console
            // TXes directly into preemptVc — NO second CHANNEL_REQ. Old
            // Rev 7 path fell back to the cached perTGChannelID, which
            // produced an unjoinable string when the server's vc allocator
            // had moved on. preemptVc is opaque (`vc[<sysKey>:<tg>:preempt-<sid>]`);
            // caller does NOT pass it through buildChannelInner.
            cb.resolve({
                status: "granted_preempt",
                preemptVc: d.preemptVc,
                preemptSessionId: d.preemptSessionId,
                displacedRid: d.displacedRid,
                displacedAlias: d.displacedAlias,
                streamIdResetRequired: d.streamIdResetRequired === true
            });
        }
    }

    _onPreemptDenied(d)
    {
        if(this._pendingPreempt) {
            clearTimeout(this._pendingPreempt.timer);
            const cb = this._pendingPreempt;
            this._pendingPreempt = null;
            cb.resolve({ status: "denied", reason: (d && d.reason) || "denied" });
        }
    }

    releaseTx(tg)
    {
        this.localActiveTxTGs.delete(tg);
        if(!this.consoleRid) return;
        // Must release under the SAME RID that keyed it, or a legacy server
        // leaves the channel stranded (granted to a RID that never released).
        this.socket.emit("CAIData", new CAIDataObject(this.systemKey,
            new CAIDataPacket(OpCodes.CHANNEL_REL, this.ridForTg(tg), 0, tg, Helper.getRandomInt(1000))));
    }

    // Inbound CAIData multiplexer. Resolves pending PTT requests on grant/deny,
    // routes ANNOUNCE/RELEASE/EMERGENCY/PATCH events to UI listeners.
    _onCAIData(obj)
    {
        if(!obj || obj.key !== this.systemKey) { return; }
        const packet = obj.packet;
        if(!packet) { return; }
        if(packet.messageID === OpCodes.CHANNEL_GRANT) {
            if(this._pendingChannelReq && packet.messageKey === this._pendingChannelReq.messageKey) {
                clearTimeout(this._pendingChannelReq.timer);
                const cb = this._pendingChannelReq;
                this._pendingChannelReq = null;
                cb.resolve({ status: "granted", channelID: packet.payload, accessibilityListenersPresent: packet.accessibilityListenersPresent === true });
            }
            return;
        }
        if(packet.messageID === OpCodes.CHANNEL_DENY) {
            if(this._pendingChannelReq && packet.messageKey === this._pendingChannelReq.messageKey) {
                clearTimeout(this._pendingChannelReq.timer);
                const cb = this._pendingChannelReq;
                this._pendingChannelReq = null;
                // Surface the server's reason code (CHANNEL_DENY.payload
                // carries TrunkingCCError) so callers can distinguish a
                // legitimate refusal (TALKGROUP_BUSY, NO_CHANNEL_FREE) from
                // a lost registration (NOT_AFFILIATED), which is recoverable.
                const denyCode = (typeof packet.payload === "string")
                    ? parseInt(packet.payload, 10) : packet.payload;
                cb.resolve({ status: "denied", reason: "channel_deny", denyCode: denyCode });
            }
            return;
        }
        if(packet.messageID === OpCodes.CHANNEL_ANNOUNCE) {
            const tg = parseInt(packet.messageKey);
            if(!isNaN(tg)) {
                this.perTGChannelID.set(tg, packet.payload);
                // Update busy-state from CAIData (replaces the dropped
                // call_started broadcast). packet.target is the talker RID,
                // packet.payload is the channelID.
                this.perTGCallState.set(tg, {
                    rid: packet.target,
                    channelID: packet.payload
                });
            }
            if(this.listeners.onChannelAnnounce) {
                try { this.listeners.onChannelAnnounce(packet); } catch(_) {}
            }
            return;
        }
        if(packet.messageID === OpCodes.CHANNEL_REL_ANNOUNCE) {
            const tg = parseInt(packet.messageKey);
            if(!isNaN(tg)) {
                this.perTGCallState.delete(tg);
            }
            if(this.listeners.onChannelReleaseAnnounce) {
                try { this.listeners.onChannelReleaseAnnounce(packet); } catch(_) {}
            }
            return;
        }
        if(packet.messageID === OpCodes.EMERGENCY) {
            this.perTGEmergencies.set(packet.payload, packet.subscriber);
            if(this.listeners.onEmergency) {
                try { this.listeners.onEmergency({ talkgroup: packet.payload, subscriber: packet.subscriber }); } catch(_) {}
            }
            return;
        }
        if(packet.messageID === OpCodes.EMERGENCY_CLEAR) {
            this.perTGEmergencies.delete(packet.payload);
            if(this.listeners.onEmergencyClear) {
                try { this.listeners.onEmergencyClear({ talkgroup: packet.payload }); } catch(_) {}
            }
            return;
        }
        if(packet.messageID === OpCodes.EMERGENCY_FORCE_CLEAR) {
            this.perTGEmergencies.delete(packet.target);
            if(this.listeners.onEmergencyClear) {
                try { this.listeners.onEmergencyClear({ talkgroup: packet.target }); } catch(_) {}
            }
            return;
        }
        if(packet.messageID === OpCodes.PATCH_ANNOUNCE && this.listeners.onPatchAnnounce) {
            try { this.listeners.onPatchAnnounce(packet); } catch(_) {}
            return;
        }
        if(packet.messageID === OpCodes.PATCH_RELEASE_ANNOUNCE && this.listeners.onPatchReleaseAnnounce) {
            try { this.listeners.onPatchReleaseAnnounce(packet); } catch(_) {}
            return;
        }
    }

    forceClearEmergency(tg)
    {
        if(!this.consoleRid) return;
        const ridUnderEmerg = this.perTGEmergencies.get(tg) || 0;
        const pkt = new CAIDataPacket(OpCodes.EMERGENCY_CLEAR, ridUnderEmerg, 0, tg, 0);
        // Match prior double-send pattern from WebRadio.clearEmergency.
        this.socket.emit("CAIData", new CAIDataObject(this.systemKey, pkt));
        this.socket.emit("CAIData", new CAIDataObject(this.systemKey, pkt));
        this.perTGEmergencies.delete(tg);
    }

    // ---- Incoming subscriber call (preempt-private audio path) ----
    //
    // Placeholder event names + payload shape — signaling agent owns the
    // final spec. Aligning here when it lands should be a 1-line rename.

    _incomingKey(talkgroup, radioRid)
    {
        return String(talkgroup) + ":" + String(radioRid);
    }

    _onIncomingSubscriberCall(d)
    {
        if(!d || d.consoleRid !== this.consoleRid) { return; }
        if(d.talkgroup === undefined || d.radioRid === undefined) { return; }
        const key = this._incomingKey(d.talkgroup, d.radioRid);
        if(this.incomingSubscriberCalls.has(key)) {
            console.debug("Duplicate incoming_subscriber_call " + key);
            return;
        }
        // Key is NEVER on the wire. Look up the TG's encryption key from the
        // view-config map populated at session construction; missing entry =>
        // clear-call (null), which voice-v3 treats as 32 zero bytes.
        const encryptionKey = this.talkgroupKeys.has(d.talkgroup)
            ? this.talkgroupKeys.get(d.talkgroup)
            : null;
        let call;
        try {
            call = new IncomingSubscriberCall(this.socket, d, encryptionKey, this.serverRev8);
        } catch(e) {
            console.error("Failed to construct IncomingSubscriberCall", e);
            return;
        }
        this.incomingSubscriberCalls.set(key, call);
        if(this.listeners.onIncomingSubscriberCall) {
            try { this.listeners.onIncomingSubscriberCall(d, call); } catch(_) {}
        }
    }

    _onIncomingSubscriberCallEnded(d)
    {
        if(!d || d.consoleRid !== this.consoleRid) { return; }
        if(d.talkgroup === undefined || d.radioRid === undefined) { return; }
        const key = this._incomingKey(d.talkgroup, d.radioRid);
        const call = this.incomingSubscriberCalls.get(key);
        if(!call) {
            console.debug("incoming_subscriber_call_ended for unknown key " + key);
            return;
        }
        try { call.teardown(); } catch(_) {}
        this.incomingSubscriberCalls.delete(key);
        if(this.listeners.onIncomingSubscriberCallEnded) {
            try { this.listeners.onIncomingSubscriberCallEnded(d); } catch(_) {}
        }
    }

    // ---- Tones ----

    // Returns true if the tone was actually emitted; false on the bonk path so
    // callers can skip local playback (otherwise the dispatcher hears a tone
    // that never reached the channel).
    async broadcastSystemTone(tg, type, tone1, tone2)
    {
        // v2_legacy is a live TX state too — tones work on legacy servers via
        // the same systemTone wire (the pre-Rev-7 console emitted it with the
        // per-channel radio RID, which ridForTg reproduces).
        const live = (this.state === "active" || this.state === "v2_legacy");
        if(!live || !this.consoleRid) {
            Tones.generateBonk();
            return false;
        }

        // On a LEGACY server a tone is a transmission, not a bare broadcast.
        // The original console (WebRadio.broadcastTone) did:
        //     CHANNEL_REQ -> await grant -> emit systemTone -> CHANNEL_REL
        // with the toning radio REGISTERed at console start and AFFILIATEd to
        // the talkgroup being toned; a denied grant bonked. Emitting
        // `systemTone` without holding a granted channel puts the event on the
        // wire but leaves no radio tuned to the call, so nothing plays it —
        // which is exactly the "tones don't reach the radios" report. Rev-7+
        // deliberately has NO grant hop (the console is affiliated to every
        // view TG and the server fans out), so this is legacy-only.
        if(this.state === "v2_legacy") {
            const res = await this.requestTx(tg);
            const granted = !!res && (res.status === "granted" || res.status === "granted_preempt");
            if(!granted) {
                console.warn("[ConsoleSession] tone denied on tg=" + tg
                    + " status=" + (res && res.status) + " reason=" + (res && res.reason)
                    + " denyCode=" + (res && res.denyCode));
                Tones.generateBonk();
                return false;
            }
            // Hold the channel for the tone's duration, then release — the
            // original slept inline before CHANNEL_REL. Deferred rather than
            // awaited so the caller's own local playback isn't serialised
            // behind it (which would double the paging cadence).
            const holdMs = (type === "HOLD") ? 1000 : 4000;
            setTimeout(() => { try { this.releaseTx(tg); } catch(_) {} }, holdMs);
        }
        // alias stamped per Rev 7 + FiveM constraint: every outbound packet
        // carries the operator's display name so downstream radios can render
        // the mid-call talker swap when a console preempts a radio.
        this.socket.emit("systemTone", {
            key: this.systemKey,
            talkgroup: tg,
            subscriber: this.ridForTg(tg),
            alias: this.consoleAlias || "",
            tone1: tone1 == null ? "" : tone1,
            tone2: tone2 == null ? "" : tone2,
            type: type
        });
        return true;
    }

    // tone_start envelope (B2026.05B server spec amendment):
    //   { streamId, key, talkgroup, subscriber, alias, type, tone1, tone2 }
    //   type ∈ {"A","B","C","HOLD","QCII"} — required.
    //   type === "QCII": both tone1 and tone2 must be non-zero QCII codes.
    //   type !== "QCII" (attention tones): tone1/tone2 = 0 (type carries the
    //   meaning; the integer fields are reserved for the QCII case).
    broadcastToneStart(streamId, tg, type, tone1, tone2)
    {
        if(!streamId || !this.consoleRid) return;
        this._localActiveStreamIds.add(streamId);
        this.socket.emit("tone_start", {
            streamId: streamId,
            key: this.systemKey,
            talkgroup: tg,
            subscriber: this.ridForTg(tg),
            alias: this.consoleAlias || "",
            type: type,
            tone1: tone1 | 0,
            tone2: tone2 | 0
        });
    }

    broadcastToneKeepalive(streamId)
    {
        if(!streamId) return;
        this.socket.emit("tone_keepalive", { streamId: streamId });
    }

    broadcastToneStop(streamId)
    {
        if(!streamId) return;
        this.socket.emit("tone_stop", { streamId: streamId });
        this._localActiveStreamIds.delete(streamId);
    }

    hasLocalToneStream(streamId)
    {
        return this._localActiveStreamIds.has(streamId);
    }

    // True if `rid` identifies THIS console on the wire — the shared console
    // RID (Rev-7+) or any of our per-channel legacy RIDs (v2_legacy stamps
    // tones/PTT with ridForTg, so self-suppression must recognize those too).
    _isSelfRid(rid)
    {
        if(rid === this.consoleRid) return true;
        if(this.legacyRidByTg) {
            for(const legacyRid of this.legacyRidByTg.values()) {
                if(rid === legacyRid) return true;
            }
        }
        return false;
    }

    // True if the operator is actually monitoring `tg` right now.
    //
    // `this.talkgroups` is the union of EVERY channel + tone TG in the view, so
    // it is not a usable audibility test on its own: it says "this view knows
    // about that TG", not "the operator is listening to it". Tones play through
    // one global oscillator (Tones.toneOscillatorContext) rather than a
    // per-channel bus, so without this check a tone sent on one channel is
    // heard on all of them — including unmonitored ones. Monitored state lives
    // on the UI layer, so it supplies this predicate; every other TG-scoped
    // event does the equivalent via its per-channel `...ForTG` handler.
    // No listener => audible, preserving behavior for embedders that don't
    // supply one.
    _isTgAudible(tg)
    {
        if(!this.listeners.isTalkgroupAudible) return true;
        try { return this.listeners.isTalkgroupAudible(tg) === true; }
        catch(_) { return true; }
    }

    _onSystemTone(tone)
    {
        if(!tone || tone.key !== this.systemKey) return;
        if(!this.talkgroups.includes(tone.talkgroup)) return;
        if(this._isSelfRid(tone.subscriber)) return;
        if(!this._isTgAudible(tone.talkgroup)) return;
        if(this.listeners.onSystemToneReceived) {
            try { this.listeners.onSystemToneReceived(tone); } catch(_) {}
        }
    }

    _onToneStart(data)
    {
        if(!data || !data.streamId) return;
        if(this._localActiveStreamIds.has(data.streamId)) {
            console.debug("Self-suppressing tone_start " + data.streamId);
            return;
        }
        if(data.key !== this.systemKey) return;
        if(!this.talkgroups.includes(data.talkgroup)) return;
        // Same audibility gate as _onSystemTone — a held attention tone on one
        // channel must not sound on every other channel in the view.
        if(!this._isTgAudible(data.talkgroup)) return;
        if(Tones.sustainedOscillators.has(data.streamId)) return;
        // Attention tones (A/B/C/HOLD) now ship with tone1=tone2=0 per the
        // amended envelope; type carries the meaning. QCII codes still live
        // in tone1/tone2 for the (rare) QCII-via-tone_start case.
        const freq = ConsoleSession.synthFreqForToneType(data.type, data.tone1, data.tone2);
        if(!freq) {
            console.warn("tone_start " + data.streamId + " no usable freq (type=" + data.type + ")");
            return;
        }
        Tones.startSustainedTone(data.streamId, freq);
    }

    // Source of truth for tone_start → local synth frequency. Used by the
    // receive handler above and by Channel.startToneHold on the emitter side
    // so emitter and receiver always pick the same frequency for a given type.
    static synthFreqForToneType(type, tone1, tone2)
    {
        switch(type) {
            case "A":    return 900;
            case "B":    return 900;
            case "C":    return 700;
            case "HOLD": return 700;
            case "QCII":
                // tone_start with QCII is unusual (the 1s/3s fixed pattern
                // stays on systemTone). If it arrives, play the first quikcall
                // tone's frequency.
                return Tones.getQuikCallFrequency(tone1) || Tones.getQuikCallFrequency(tone2) || 0;
            default:
                return 0;
        }
    }

    _onToneStop(data)
    {
        if(!data || !data.streamId) return;
        if(this._localActiveStreamIds.has(data.streamId)) return;
        if(!Tones.sustainedOscillators.has(data.streamId)) return;
        Tones.stopSustainedTone(data.streamId);
    }

    // ---- Channel-name builder (used by Channel for voice routing) ----

    buildChannelInner(channelPayload, encryptionKey)
    {
        const audioVersion = (typeof window !== "undefined" && window.__SCN_AUDIO_VERSION) || "v2";
        const base = this.systemKey + ":" + channelPayload;
        if(audioVersion === "v3") { return base; }
        if(encryptionKey !== undefined && encryptionKey !== null) {
            return base + "$" + encryptionKey;
        }
        return base;
    }
}

class WebRadio {
    metadataCallback = undefined;
    #currentChannelState = new StateChecker();
    #currentUI = {
        line1 : "",
        line2: "",
        statusLED: "off"
    }
    #handleData = false;
    #subscriberID = 0;
    #websocket = undefined;
    #systemID = undefined;
    #affiliationState = -1;
    #talkgroup = 0;
    #voice = undefined;
    #eventCB = undefined;
    #channelReqCallback = undefined;
    #securekey = false;
    #rxActive = false;
    #broadcastingTones = false
    #channelHold = false
    #channelHoldState = new StateChecker();
    #activePatch = null; // Stores array of talkgroups in active patch
    // streamIds we're currently emitting locally; receive handler suppresses
    // these to avoid double-playing our own broadcast.
    #localActiveStreamIds = new Set();

    /**
     * @param {number} subscriberID
     * @param {Socket} websocket
     * @param {string} systemID
     */
    constructor(subscriberID,websocket,systemID)
    {
        console.log(`Init webradio ID ${subscriberID}`)
        this.#systemID = systemID;
        this.#subscriberID = subscriberID;
        this.#websocket = websocket;
        this.#handleData = true;
        this.#websocket.on("systemTone",data => {
            this.#handleTone(data).then(r => {});
        })
        this.#websocket.on("tone_start", data => {
            this.#handleToneStart(data);
        })
        this.#websocket.on("tone_stop", data => {
            this.#handleToneStop(data);
        })
        this.#websocket.on("CAIData",data => {
            this.#handleCAIData(data)
        })
        this.#voice = new Voice(this.#websocket);
        this.#voice.setSubscriber(subscriberID);
        this.#voice.cbVoiceMetadata = (data)=>{
            if(this.metadataCallback!==undefined&&this.metadataCallback!==null)
            {
                this.metadataCallback(data)
            }
        }
        this.#runPingThread().then();
    }

    async setChannelHold(state) {
        console.info(`Channel hold state set to ${state}`)
        this.channelHold = state;
        let chstate = this.#channelHoldState = new StateChecker();
        if(state === true)
        {
            while(this.channelHold===true && chstate.isSame(this.#channelHoldState)) {
                console.debug("Begin channel hold loop")
                while (this.localPTTState === true || this.#rxActive === true) {
                    console.debug("Check for free channel...")
                    let waited = false;
                    console.debug("Check local PTT state:",this.localPTTState)
                    while (this.localPTTState === true) {
                        console.debug("Wait for Tx clear")
                        waited = true;
                        await Helper.sleep(250);
                    }
                    console.debug("Check rx active:",this.#rxActive)
                    while (this.#rxActive === true)
                    {
                        console.debug("Wait for Rx clear, current channel = " + this.#voice.currentChannel);
                        waited = true;
                        await Helper.sleep(250);
                    }
                    if (waited) {
                        console.debug("Wait to give other users a chance...")
                        await Helper.sleep(1000);
                    }
                    await Helper.sleep(1);

                }
                console.debug("Broadcast hold...")
                this?.#eventCB({"id": "tx", status: true})
                await this.broadcastTone("HOLD", 0, 0);
                this?.#eventCB({"id": "tx", status: false})
                await Helper.sleep(10000)
            }
        }
    }

    setAudioDevice(device) {
        this.#voice.setAudioDevice(device);
    }


    getQuikCallFrequency(target) {
        switch (Number(target)) {
            case 110:
                return 330.5;
            case 111:
                return 349;
            case 112:
                return 368.5;
            case 113:
                return 389;
            case 114:
                return 410.8;
            case 115:
                return 433.7;
            case 116:
                return 457.9;
            case 117:
                return 483.5;
            case 118:
                return 510.5;
            case 119:
                return 539;
            case 120:
                return 569.1;
            case 121:
                return 600.9;
            case 122:
                return 634.5;
            case 123:
                return 669.9;
            case 124:
                return 707.3;
            case 125:
                return 746.8;
            case 126:
                return 788.5;
            case 127:
                return 832.5;
            case 128:
                return 879;
            case 129:
                return 928.1;
            case 138:
                return 288.5;
            case 108:
                return 296.5;
            case 139:
                return 304.7;
            case 109:
                return 313.8;
            case 160:
                return 953.7;
            case 130:
                return 979.9;
            case 161:
                return 1006.9;
            case 131:
                return 1034.7;
            case 162:
                return 1063.2;
            case 189:
                return 1092.4;
            case 140:
                return 321.7;
            case 141:
                return 339.6;
            case 142:
                return 358.6;
            case 143:
                return 378.6;
            case 144:
                return 399.8;
            case 145:
                return 422.1;
            case 146:
                return 445.7;
            case 147:
                return 470.5;
            case 148:
                return 496.8;
            case 149:
                return 524.6;
            case 150:
                return 553.9;
            case 151:
                return 584.8;
            case 152:
                return 617.4;
            case 153:
                return 651.9;
            case 154:
                return 688.3;
            case 155:
                return 726.8;
            case 156:
                return 767.4;
            case 157:
                return 810.2;
            case 158:
                return 855.5;
            case 159:
                return 903.2;
            case 190:
                return 1122.5;
            case 191:
                return 1153.4;
            case 192:
                return 1185.2;
            case 193:
                return 1217.8;
            case 194:
                return 1251.4;
            case 195:
                return 1285.8;
            case 196:
                return 1321.2;
            case 197:
                return 1357.6;
            case 198:
                return 1395;
            case 199:
                return 1433.4;
            case 170:
                return 1472.9;
            case 171:
                return 1513.5;
            case 172:
                return 1555.2;
            case 173:
                return 1598;
            case 174:
                return 1642;
            case 175:
                return 1687.2;
            case 176:
                return 1733.7;
            case 177:
                return 1781.5;
            case 178:
                return 1830.5;
            case 179:
                return 1881;
            case 200:
                return 1930.2;
            case 201:
                return 1989;
            case 202:
                return 2043.8;
            case 203:
                return 2094.5;
            case 204:
                return 2155.6;
            case 205:
                return 2212.2;
            case 206:
                return 2271.7;
            case 207:
                return 2334.6;
            case 208:
                return 2401;
            case 209:
                return 2468.2;
        }
    }

    generateQuikCallPage = (tone1, tone2) => {
        Tones.generateTone(this.getQuikCallFrequency(tone1), 1000, () => {
            Tones.generateTone(this.getQuikCallFrequency(tone2), 3000)
        })
    }

    async broadcastAlertTone(type)
    {
        console.debug("Broadcast tone "+type);
        Tones.playAlertTone(type)
        this.#websocket.emit('systemTone',{
            key:this.#systemID,
            talkgroup: this.#talkgroup,
            subscriber: this.#subscriberID,
            tone1: "",
            tone2: "",
            type: type
        })
        if(type === "HOLD")
        {
            await Helper.sleep(1000);
        }
        else
            await Helper.sleep(4000);
    }

    async broadcastQCIITone(tone1, tone2, type)
    {
        console.debug("Broadcast QCII "+tone1+" "+tone2);
        this.generateQuikCallPage(tone1,tone2);

        this.#websocket.emit('systemTone',{
            key:this.#systemID,
            talkgroup: this.#talkgroup,
            subscriber: this.#subscriberID,
            tone1: tone1,
            tone2: tone2,
            type: type
        })
        await Helper.sleep(4000);
    }

    // v3 hold-to-talk: emit tone_start. Caller drives local audio and the
    // keepalive interval separately; this method only writes the wire event
    // and records the streamId for self-suppression on receive.
    broadcastToneStart(streamId, type, tone1, tone2)
    {
        if(!streamId) { return; }
        this.#localActiveStreamIds.add(streamId);
        this.#websocket.emit("tone_start", {
            streamId: streamId,
            key: this.#systemID,
            talkgroup: this.#talkgroup,
            subscriber: this.#subscriberID,
            tone1: tone1|0,
            tone2: tone2|0
        });
    }

    broadcastToneKeepalive(streamId)
    {
        if(!streamId) { return; }
        this.#websocket.emit("tone_keepalive", { streamId: streamId });
    }

    broadcastToneStop(streamId)
    {
        if(!streamId) { return; }
        this.#websocket.emit("tone_stop", { streamId: streamId });
        this.#localActiveStreamIds.delete(streamId);
    }

    hasLocalToneStream(streamId)
    {
        return this.#localActiveStreamIds.has(streamId);
    }

    async broadcastTone(type,tone1="",tone2="")
    {
        try {
            this.#broadcastingTones = true;
            console.info("Broadcast tone type " + type);
            let result = undefined;
            console.debug("Requesting channel");
            this.sendPacket(new CAIDataPacket(OpCodes.CHANNEL_REQ, this.#subscriberID, this.#talkgroup, this.#talkgroup, Helper.getRandomInt(1000)))
            this.#channelReqCallback = (packet) => {
                console.debug("Got callback");
                console.debug("Result: ",packet);
                result = packet;
            }
            let counter = 0;
            while (result === undefined && (counter += 1 <= 10000)) {
                await Helper.sleep(1);
            }
            console.debug("Result: ",result);
            if (result.messageID === OpCodes.CHANNEL_GRANT) {
                console.debug("Channel Grant successful, broadcasting tone");
                if (type === "QCII") {
                    await this.broadcastQCIITone(tone1, tone2, type);
                } else {
                    await this.broadcastAlertTone(type);
                }
                this.sendPacket(new CAIDataPacket(OpCodes.CHANNEL_REL,this.#subscriberID,0,this.#talkgroup,Helper.getRandomInt(1000)))
            } else {
                console.error("Channel Grant failed");
                Tones.generateBonk();
            }
        }
        catch(e)
        {

        }
        finally{
            this.#broadcastingTones = false;
        }

    }

    setEventCallback(cb)
    {
        this.#eventCB = cb;
    }

    deregister()
    {
        this.#handleData = false;
        // this.sendPacket(new CAIDataPacket(OpCodes.DEREGISTER,this.#subscriberID,0,0,0));
        // For multiradio, don't actually deregister the SU to prevent issues with other consoles
        // Instead, just ignore any additional data directed at this one
        this.#affiliationState = -1;
    }

    register()
    {

        this.#handleData = true;
        this.sendPacket(new CAIDataPacket(OpCodes.REGISTER,this.#subscriberID,0,0,Helper.getRandomInt(1000)));
    }

    delete()
    {
        // stop handling CAI data
        this.#systemID = "";
    }

    async #runPingThread()
    {
        while(true)
        {
            console.debug("Run ping thread...")
            if(this.#affiliationState!==-1)
            {
                console.debug("Radio registered, activating ping");
                this.sendPacket(new CAIDataPacket(OpCodes.REMOTE_PING_RESPONSE,this.#subscriberID,0,0,0));
            }
            await Helper.sleep(10000);
        }
    }

    async #handleTone(tone)
    {
        if(!this.#handleData || this.#broadcastingTones)
        {
            return;
        }
        if(tone.key === this.#systemID && tone.talkgroup === this.#talkgroup)
        {
            if (tone.type === "QCII") {
                await this.generateQuikCallPage(tone.tone1, tone.tone2);
            } else {
                await Tones.playAlertTone(tone.type);
            }
        }
    }

    #handleToneStart(data)
    {
        if(!this.#handleData) { return; }
        if(!data || !data.streamId) { return; }
        if(this.#localActiveStreamIds.has(data.streamId)) {
            console.debug("Self-suppressing tone_start "+data.streamId);
            return;
        }
        if(data.key !== this.#systemID || data.talkgroup !== this.#talkgroup) {
            return;
        }
        if(Tones.sustainedOscillators.has(data.streamId)) {
            console.debug("Duplicate tone_start "+data.streamId+", ignoring");
            return;
        }
        let freq = (data.tone1 && data.tone1 !== 0) ? data.tone1 : data.tone2;
        if(!freq) {
            console.warn("tone_start "+data.streamId+" has no usable freq (0/0)");
            return;
        }
        Tones.startSustainedTone(data.streamId, freq);
    }

    #handleToneStop(data)
    {
        if(!data || !data.streamId) { return; }
        if(this.#localActiveStreamIds.has(data.streamId)) {
            // Our own broadcast — local audio was already stopped by the
            // emitter path. Don't touch the streamId set here; the emitter
            // calls broadcastToneStop() which removes it.
            return;
        }
        if(!Tones.sustainedOscillators.has(data.streamId)) {
            console.debug("tone_stop for unknown streamId "+data.streamId+", ignoring");
            return;
        }
        Tones.stopSustainedTone(data.streamId);
    }

    /**
     * @param {CAIDataObject} CAIDataObject
     */
    #handleCAIData(CAIDataObject)
    {
        if(!this.#handleData)
        {
            return;
        }
        if(CAIDataObject.key === this.#systemID)
        {
            console.debug(`Got CAIData ${JSON.stringify(CAIDataObject)}`);
            let packet = CAIDataObject.packet;
            switch (packet.messageID)
            {
                case OpCodes.REGISTRATION_OK:
                    if(packet.target === this.#subscriberID)
                    {
                        console.debug(`Subscriber ${this.#subscriberID} reg OK`)
                        this.#affiliationState = 0;
                    }
                    break;
                case OpCodes.AFFILIATE_OK:
                    if(packet.target === this.#subscriberID)
                    {
                        console.debug(`Subscriber ${this.#subscriberID} aff OK to ${packet.payload}`)
                        this.#talkgroup = packet.payload;
                        this.#affiliationState = packet.payload;
                    }
                    break;
                case OpCodes.AFFILIATE_DENIED:
                    if(packet.target === this.#subscriberID)
                    {
                        this.sendPacket(new CAIDataPacket(OpCodes.REGISTER,this.#subscriberID,0,0,Helper.getRandomInt(1000)))
                        console.debug(`Subscriber ${this.#subscriberID} aff DENIED to ${packet.payload}`)
                        this.#affiliationState = -1;
                    }
                    break;
                case OpCodes.EMERGENCY:
                    if(packet.payload.toString() === this.#talkgroup.toString())
                    {
                        if(this.#eventCB!==undefined)
                        {
                            // noinspection JSValidateTypes
                            this.#eventCB({id:"emerg","subscriber":packet.subscriber})
                        }
                    }
                    break;
                case OpCodes.EMERGENCY_CLEAR:
                    if(packet.payload.toString() === this.#talkgroup.toString())
                    {
                        if(this.#eventCB!==undefined)
                        {
                            // noinspection JSValidateTypes
                            this.#eventCB({id:"emerg_clear"})
                        }
                    }
                    break;
                case OpCodes.EMERGENCY_FORCE_CLEAR:
                    if(packet.target.toString() === this.#talkgroup.toString())
                    {
                        if(this.#eventCB!==undefined)
                        {
                            // noinspection JSValidateTypes
                            this.#eventCB({id:"emerg_clear"})
                        }
                    }
                    break;
                case OpCodes.PATCH_ANNOUNCE:
                    // Parse patch announcement: target contains the primary TG to monitor, payload contains all groups in patch
                    // All radios affiliated to any TG in the patch should monitor the target (primary) talkgroup
                    console.log(`[Radio ${this.#subscriberID}] PATCH_ANNOUNCE received - Primary TG: ${packet.target}, Groups: ${packet.payload}`);
                    if(typeof packet.payload === 'string' && packet.payload.includes('|'))
                    {
                        const patchGroups = packet.payload.split('|').map(tg => parseInt(tg.trim()));
                        const primaryTalkgroup = parseInt(packet.target);
                        console.log(`[Radio ${this.#subscriberID}] Parsed patch - Primary: ${primaryTalkgroup}, All groups: [${patchGroups.join(', ')}]`);

                        // Check if our affiliated talkgroup is anywhere in the patch
                        if(patchGroups.includes(this.#talkgroup))
                        {
                            // Store the patch with the target as the monitoring talkgroup
                            this.#activePatch = {
                                primaryTalkgroup: primaryTalkgroup, // Monitor this TG (from packet.target)
                                allTalkgroups: patchGroups // All TGs in patch
                            };
                            console.log(`[Radio ${this.#subscriberID}] ✓ PATCH ACTIVE: TG ${this.#talkgroup} will now monitor primary TG ${primaryTalkgroup}`);
                            console.log(`[Radio ${this.#subscriberID}] Complete patch group: [${patchGroups.join(', ')}]`);
                        }
                        else
                        {
                            console.log(`[Radio ${this.#subscriberID}] ✗ Patch not applicable (affiliated to TG ${this.#talkgroup})`);
                        }
                    }
                    break;
                case OpCodes.PATCH_RELEASE_ANNOUNCE:
                    // Clear active patch
                    console.log(`[Radio ${this.#subscriberID}] PATCH_RELEASE_ANNOUNCE received`);
                    if(this.#activePatch !== null)
                    {
                        console.log(`[Radio ${this.#subscriberID}] ✓ Patch released for TG ${this.#talkgroup} (was monitoring TG ${this.#activePatch.primaryTalkgroup})`);
                        this.#activePatch = null;
                    }
                    else
                    {
                        console.log(`[Radio ${this.#subscriberID}] ✗ No active patch to release`);
                    }
                    break;
                case OpCodes.CHANNEL_ANNOUNCE:
                    // Check if this is for our talkgroup OR for the primary patched talkgroup
                    console.log(`[Radio ${this.#subscriberID}] CHANNEL_ANNOUNCE received - TG: ${packet.messageKey}, Channel: ${packet.payload}, Subscriber: ${packet.target}`);
                    console.log(`[Radio ${this.#subscriberID}] Current state - Affiliated TG: ${this.#talkgroup}, Active Patch: ${this.#activePatch !== null ? 'YES (Primary: ' + this.#activePatch.primaryTalkgroup + ')' : 'NO'}, PTT: ${this.localPTTState}, rxActive: ${this.#rxActive}`);

                    // If we're already receiving and have an active patch, ignore grants for our own TG
                    if(this.#rxActive && this.#activePatch !== null && packet.messageKey.toString() === this.#talkgroup.toString())
                    {
                        console.log(`[Radio ${this.#subscriberID}] ⏭️ Ignoring own TG grant (already receiving patched call)`);
                        break;
                    }

                    let shouldReceive = packet.messageKey.toString() === this.#talkgroup.toString();

                    // If we have an active patch, check if the grant is for the PRIMARY talkgroup
                    if(!shouldReceive && this.#activePatch !== null)
                    {
                        const grantTalkgroup = parseInt(packet.messageKey.toString());
                        console.log(`[Radio ${this.#subscriberID}] Checking patch: Grant TG ${grantTalkgroup} vs Primary TG ${this.#activePatch.primaryTalkgroup}`);
                        shouldReceive = grantTalkgroup === this.#activePatch.primaryTalkgroup;
                        if(shouldReceive)
                        {
                            console.log(`[Radio ${this.#subscriberID}] 📞 Following PATCHED call on primary TG ${grantTalkgroup} (affiliated to TG ${this.#talkgroup})`);
                        }
                        else
                        {
                            console.log(`[Radio ${this.#subscriberID}] ✗ Ignoring channel grant for TG ${grantTalkgroup} (monitoring primary TG ${this.#activePatch.primaryTalkgroup})`);
                        }
                    }

                    console.log(`[Radio ${this.#subscriberID}] Decision: shouldReceive=${shouldReceive}, localPTTState=${this.localPTTState}`);

                    if(!this.localPTTState && shouldReceive)
                    {
                        // Check if we're already on this channel - don't re-tune
                        const channelID = this.#buildChannelInner(packet.payload);

                        if(this.#rxActive && this.#voice.currentChannel === "vc["+channelID+"]")
                        {
                            console.log(`[Radio ${this.#subscriberID}] ⏭️ Already on channel ${packet.payload}, ignoring duplicate grant`);
                            break;
                        }

                        console.log(`[Radio ${this.#subscriberID}] ✓ Tuning to voice channel: ${packet.payload}`);
                        this.#currentChannelState = new StateChecker();
                        // Register the per-channel key with the voice driver
                        // BEFORE joining, so v3 decoder construction can read
                        // it synchronously. v2 implements this as a no-op.
                        if (typeof this.#voice.setEncryptionKey === "function") {
                            this.#voice.setEncryptionKey("vc["+channelID+"]", this.#securekey);
                        }
                        this.#voice.setVoiceChannel(channelID);
                        this.#rxActive = true;
                        if(this.#eventCB!==undefined)
                        {
                            // noinspection JSValidateTypes
                            this.#eventCB({id:"rx","subscriber":packet.target})
                        }
                        console.log(`[Radio ${this.#subscriberID}] ✓ Voice channel set, rxActive=${this.#rxActive}`);
                    }
                    else
                    {
                        console.log(`[Radio ${this.#subscriberID}] ✗ NOT tuning - Reason: ${this.localPTTState ? 'PTT active' : 'shouldReceive=false'}`);
                    }
                    break;
                case OpCodes.CHANNEL_REL_ANNOUNCE:
                    // Check if release is for our talkgroup or the primary patched talkgroup
                    let shouldRelease = packet.messageKey.toString() === this.#talkgroup.toString();

                    if(!shouldRelease && this.#activePatch !== null)
                    {
                        const releaseTalkgroup = parseInt(packet.messageKey.toString());
                        shouldRelease = releaseTalkgroup === this.#activePatch.primaryTalkgroup;
                    }

                    if(shouldRelease)
                    {
                        let releaseState = this.#currentChannelState = new StateChecker();
                        setTimeout(()=>{
                            if(releaseState.isSame(this.#currentChannelState)) {
                                this.#voice.leaveVoiceChannel()
                                this.#rxActive = false;

                                // Clear patch state when call ends
                                if(this.#activePatch !== null)
                                {
                                    console.log(`[Radio ${this.#subscriberID}] 🔚 Clearing patch state after call end (was monitoring TG ${this.#activePatch.primaryTalkgroup})`);
                                    this.#activePatch = null;
                                }

                                if (this.#eventCB !== undefined) {
                                    // noinspection JSValidateTypes
                                    this.#eventCB({id: "release"})
                                }
                            }
                        },2000)

                    }
                    break;
                case OpCodes.CHANNEL_GRANT:
                case OpCodes.CHANNEL_DENY:
                    if(this.#channelReqCallback!=undefined)
                    {
                        this.#channelReqCallback(packet);
                    }
            }
        }
    }

    sendPacket(CAIDataPacket)
    {
        console.debug(`Send CAIData ${JSON.stringify(CAIDataPacket)}`);
        this.#websocket.emit("CAIData",new CAIDataObject(this.#systemID,CAIDataPacket));
    }

    // Build the inner portion (the bit between `vc[` and `]`) of the voice
    // channel name for a given channelID payload. v2 keeps the legacy
    // `systemID:channelID$encryptionKey` format because the room name is the
    // access-control mechanism on the legacy path. v3 uses the keyless
    // `systemID:channelID` form — keys are plumbed separately via
    // voice.setEncryptionKey() and never appear on the wire.
    #buildChannelInner(channelPayload)
    {
        const audioVersion = (typeof window !== "undefined" && window.__SCN_AUDIO_VERSION) || "v2";
        const base = this.#systemID + ":" + channelPayload;
        if (audioVersion === "v3") {
            return base;
        }
        if (this.#securekey !== undefined && this.#securekey !== null) {
            return base + "$" + this.#securekey;
        }
        return base;
    }

    async #affiliateTalkgroup(talkgroupID,key = null)
    {
        this.#securekey = key;
        if(!this.#handleData)
        {
            this.#handleData = true;
        }
        if(this.#affiliationState===-1)
        {
            console.log("Registering to system...")
            this.sendPacket(new CAIDataPacket(OpCodes.REGISTER,this.#subscriberID,0,0,Helper.getRandomInt(1000)))
        }
        while(this.#affiliationState===-1)
        {
            await Helper.sleep(1);
        }
        this.sendPacket(new CAIDataPacket(OpCodes.AFFILIATE,this.#subscriberID,0,talkgroupID,0))
        while(this.#talkgroup!==talkgroupID)
        {
            await Helper.sleep(1);
        }
    }

    async setTalkgroup(talkgroupID,key = null)
    {
        if(talkgroupID === 0)
        {
            this.sendPacket(new CAIDataPacket(OpCodes.DEAFFILIATE,this.#subscriberID,0,talkgroupID,0))
            await Helper.sleep(100)
        }
        else
        {
            await this.#affiliateTalkgroup(talkgroupID,key)
        }
        this.#talkgroup = talkgroupID;
    }

    getTalkgroup()
    {
        return this.#talkgroup;
    }

    getSubscriberID()
    {
        return this.#subscriberID;
    }


    localPTTState = false;

    async downPTT()
    {
        if(!this.localPTTState)
        {
            this.localPTTState = true;
            if(this.#affiliationState === this.#talkgroup)
            {
                let result = undefined;
                // noinspection DuplicatedCode
                let messageKey = Helper.getRandomInt(1000);
                this.sendPacket(new CAIDataPacket(OpCodes.CHANNEL_REQ,this.#subscriberID,0,this.#talkgroup,messageKey))
                this.#channelReqCallback = (packet) => {
                    console.debug("Got response packet",packet)
                    if(packet.messageKey === messageKey) {
                        console.log("Got response to PTT request",packet)
                        result = packet;
                    }
                }
                let counter = 0;
                while(result===undefined&&(counter+=1<=10000))
                {
                    await Helper.sleep(1);
                }
                if(result.messageID===OpCodes.CHANNEL_GRANT)
                {
                    const channelID = this.#buildChannelInner(result.payload);
                    if (typeof this.#voice.setEncryptionKey === "function") {
                        this.#voice.setEncryptionKey("vc["+channelID+"]", this.#securekey);
                    }
                    this.#voice.setVoiceChannel(channelID);
                    // Read accessibility listener flag off the grant; encoder
                    // will use it to decide whether to expose PCM.
                    try {
                        const accListeners = result && result.accessibilityListenersPresent;
                        if (typeof this.#voice.setAccessibilityListenersPresent === "function") {
                            this.#voice.setAccessibilityListenersPresent(accListeners === true);
                        }
                    } catch (_) {}
                    this.#voice.setPTT(true);
                    Tones.generatePTT(true);
                    return true;
                }
                else
                {
                    Tones.generateBonk();
                    return false;
                }
            }
            else
            {
                return false;
            }
        }
        else
        {
            return;
        }
    }

    async upPTT()
    {
        if(this.localPTTState)
        {
            this.localPTTState = false;
            this.sendPacket(new CAIDataPacket(OpCodes.CHANNEL_REL,this.#subscriberID,0,this.#talkgroup,Helper.getRandomInt(1000)))
            this.#voice.setPTT(false);
        }
        else
        {
            return;
        }
    }
}
// CommonJS export for the Node-based unit tests (tests/). No-op in the browser.
if (typeof module !== "undefined" && module.exports) {
    module.exports = { Helper, ConsoleSession, IncomingSubscriberCall, OpCodes, CAIDataPacket, CAIDataObject };
}
